import { ENUM_AdvisorUserPermissionLevel } from '@api-new/common';
import { HTTP_AP_ListClientUsers_ForTable_Request_Sort } from '@api-new/userservice';
import { ClientTableRowModel } from '@platform/client/models/client-table.model';
import { ClientTableFilterModel } from '@platform/client/pages/client-table/models/client-table-filter.model';
import { RowDefinitionTypeEnum } from '@shared/components/table/enums/row-definition-type.enum';
import { TableRowDefinitionModel } from '@shared/components/table/models/table-row-definition.model';
import { PermissionEnum } from '@shared/enums/permission.enum';
import { HasCurrentUserRequiredPermissionsFunctionModel } from '@shared/services/permission.service';

export const clientTableFilterDefaults: ClientTableFilterModel = {
  clientUserDisplayNameOrEmail: '',
  advisorUserDisplayNameOrEmail: '',
  clientUserHasNoAdvisorUser: false,
  referralCode: '',
  clientUserCreatedAt: null,
  clientUserLastSignIn: null,
  propertyCount: { min: null, max: null },
  mortgageCount: { min: null, max: null },
  betterDealAlertNotificationsEnabled: null,
  homeReportNotificationsEnabled: null,
  networkIds: [],
  companyIds: [],
  creationMethod: null,
  clientUserHasPendingResidentialPropertyCompletion: null,
};

export const clientTableRowDefinition = (
  hasCurrentUserRequiredPermissions: HasCurrentUserRequiredPermissionsFunctionModel,
): TableRowDefinitionModel<ClientTableRowModel, HTTP_AP_ListClientUsers_ForTable_Request_Sort>[] => [
  {
    columnLabel: 'Client name',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'clientUserDisplayName',
    sortKey: 'byClientUserDisplayName',
    width: {
      min: '240px',
      max: '240px',
    },
    isFrozen: true,
  },
  {
    columnLabel: 'Company',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'companyTradingName',
    sortKey: 'byCompanyTradingName',
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.ClientUserRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_COMPANY,
      },
    ]),
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Assigned to',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'advisorUserDisplayName',
    sortKey: 'byAdvisorUserDisplayName',
    isHidden: !hasCurrentUserRequiredPermissions([
      {
        permission: PermissionEnum.ClientUserRead,
        permissionLevel: ENUM_AdvisorUserPermissionLevel.ADVISOR_USER_PERMISSION_LEVEL_DIRECT,
      },
    ]),
    width: {
      min: '200px',
      max: '200px',
    },
  },
  {
    columnLabel: 'Created',
    type: RowDefinitionTypeEnum.DateTimeSince,
    columnKey: 'clientUserCreatedAt',
    sortKey: 'byClientUserCreatedAt',
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Source',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'clientUserCreationMethod',
    width: {
      min: '70px',
      max: '90px',
    },
  },
  {
    columnLabel: 'Ref. code',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'referralCode',
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Last login',
    type: RowDefinitionTypeEnum.DateTimeSince,
    columnKey: 'clientUserLastSignIn',
    sortKey: 'byClientUserLastSignIn',
    width: {
      min: '120px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Properties',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'propertyCount',
    sortKey: 'byPropertyCount',
    width: {
      min: '100px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Total properties value',
    type: RowDefinitionTypeEnum.Currency,
    columnKey: 'sumOfPropertiesCurrentValueAsOwnershipShare',
    width: {
      min: '100px',
      max: '150px',
    },
  },
  {
    columnLabel: 'Equity',
    type: RowDefinitionTypeEnum.Currency,
    columnKey: 'sumOfEquities',
    width: {
      min: '100px',
      max: '150px',
    },
  },

  {
    columnLabel: 'Mortgages',
    type: RowDefinitionTypeEnum.Text,
    columnKey: 'mortgageCount',
    sortKey: 'byMortgageCount',
    width: {
      min: '100px',
      max: '120px',
    },
  },
  {
    columnLabel: 'Notifications',
    type: RowDefinitionTypeEnum.NotificationSettings,
    columnKey: 'notificationSettings',
    width: {
      min: '125px',
      max: '140px',
    },
  },
  {
    columnLabel: 'Flags',
    type: RowDefinitionTypeEnum.Image,
    columnKey: 'clientUserHasPendingResidentialPropertyCompletion',
    width: {
      min: '70px',
      max: '70px',
    },
  },
];
